// [VinUni] Quản lý đề tài - hằng số trạng thái / cấp / vai trò / thời lượng.

// Hệ màu NGỮ NGHĨA (neutral / info / active / warning / success / error / done)
// thay cho 9 màu Material ngẫu nhiên trước đây.
export const TOPIC_STATUS = {
  draft: { label: "Nháp", color: "#78909c" }, // neutral
  pendingSubmit: { label: "Nháp", color: "#78909c" }, // (deprecated) coi như Nháp
  submitted: { label: "Đã nộp", color: "#1e88e5" }, // info
  inProgress: { label: "Đang thực hiện", color: "#3949ab" }, // active
  suspended: { label: "Tạm dừng", color: "#f9a825" }, // warning
  pendingAcceptance: { label: "Chờ nghiệm thu", color: "#5e35b1" }, // pending decision
  accepted: { label: "Đạt nghiệm thu", color: "#2e7d32" }, // success
  failed: { label: "Không đạt", color: "#d32f2f" }, // error
  closed: { label: "Đóng đề tài", color: "#455a64" }, // done
};

// Backbone hiển thị trên Stepper (một chiều). "Tạm dừng" là badge trên bước
// "Đang thực hiện"; "Đạt/Không đạt" là kết quả tại bước "Nghiệm thu".
export const TOPIC_STEPS = [
  { key: "draft", label: "Nháp" },
  { key: "submitted", label: "Đã nộp" },
  { key: "inProgress", label: "Đang thực hiện" },
  { key: "pendingAcceptance", label: "Nghiệm thu" },
  { key: "closed", label: "Đóng" },
];

// Vị trí (index) của một trạng thái trên backbone ở trên.
export const topicStepIndex = (status) => {
  switch (status) {
    case "draft":
    case "pendingSubmit":
      return 0;
    case "submitted":
      return 1;
    case "inProgress":
    case "suspended":
      return 2;
    case "pendingAcceptance":
    case "accepted":
    case "failed":
      return 3;
    case "closed":
      return 4;
    default:
      return 0;
  }
};

// Nhãn tiếng Việt cho trạng thái yêu cầu con (gia hạn / xin dừng).
export const REQUEST_STATUS_LABEL = {
  pending: "Chờ duyệt",
  approved: "Đã duyệt",
  rejected: "Từ chối",
};
export const requestStatusLabel = (s) => REQUEST_STATUS_LABEL[s] || s;

// Các TAB hiển thị trong màn chi tiết theo trạng thái (giao diện đổi theo trạng thái).
// Tab luôn có: "info", "members". Các tab hoạt động chỉ bật khi hợp lệ.
export const topicVisibleTabs = (status) => {
  const base = ["info", "members"];
  switch (status) {
    case "inProgress":
    case "suspended":
      return [...base, "progress", "extension", "stop", "email"];
    case "pendingAcceptance":
      return [...base, "progress", "acceptance", "email"];
    case "accepted":
    case "failed":
    case "closed":
      return [...base, "progress", "acceptance"];
    default: // draft, submitted — chưa có hoạt động
      return base;
  }
};

export const TOPIC_LEVELS = [
  { value: "ministry", label: "Bộ / Trọng điểm của Bộ" },
  { value: "state", label: "Nhà nước / Quốc gia" },
  { value: "province", label: "Tỉnh / Thành phố" },
  { value: "school", label: "Cơ sở (Trường / Khoa)" },
  { value: "nafosted", label: "Nafosted" },
  { value: "other", label: "Khác" },
];

export const TOPIC_ROLES = [
  { value: "leader", label: "Chủ nhiệm" },
  { value: "coLeader", label: "Đồng chủ nhiệm" },
  { value: "secretary", label: "Thư ký" },
  { value: "member", label: "Thành viên" },
];

export const TOPIC_MEMBER_TYPES = [
  { value: "internal", label: "Thành viên nội bộ" },
  { value: "external", label: "Thành viên ngoài trường" },
  { value: "student", label: "Sinh viên / Học viên" },
];

export const TOPIC_DURATIONS = [
  { value: 12, label: "12 tháng" },
  { value: 18, label: "18 tháng" },
  { value: 24, label: "24 tháng" },
  { value: 30, label: "30 tháng" },
  { value: 36, label: "36 tháng" },
];

export const TOPIC_DEADLINE_BUCKETS = [
  { value: "", label: "Tất cả" },
  { value: "30", label: "Còn dưới 30 ngày" },
  { value: "15", label: "Còn dưới 15 ngày" },
  { value: "7", label: "Còn dưới 7 ngày" },
  { value: "overdue", label: "Đã quá hạn" },
  { value: "stale", label: "Lâu chưa cập nhật" },
];

export const statusLabel = (s) => (TOPIC_STATUS[s] ? TOPIC_STATUS[s].label : s);
export const statusColor = (s) => (TOPIC_STATUS[s] ? TOPIC_STATUS[s].color : "#9e9e9e");
export const levelLabel = (v) => {
  const found = TOPIC_LEVELS.find((l) => l.value === v);
  return found ? found.label : v;
};
export const roleLabel = (v) => {
  const found = TOPIC_ROLES.find((l) => l.value === v);
  return found ? found.label : v;
};
